import script from "./ProfileForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileForm.vue?vue&type=style&index=0&id=06de27cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06de27cc"]])

export default __exports__